"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoginInfo = exports.setToken = exports.login = void 0;
var reducer_1 = require("./reducer");
Object.defineProperty(exports, "login", { enumerable: true, get: function () { return reducer_1.reducer; } });
var action_1 = require("./action");
Object.defineProperty(exports, "setToken", { enumerable: true, get: function () { return action_1.setToken; } });
Object.defineProperty(exports, "getLoginInfo", { enumerable: true, get: function () { return action_1.getLoginInfo; } });
